import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

/**
 * Renders an instrument name clamped to 2 lines with ellipsis.
 * When truncated, sets the native title so hover shows the full value.
 */
const InstrumentTitle = ({ text, className = 'instrument-title' }) => {
  const ref = useRef(null)
  const [tooltip, setTooltip] = useState(undefined)

  const updateTruncation = useCallback(() => {
    const el = ref.current
    if (!el || text == null || text === '') {
      setTooltip(undefined)
      return
    }
    // +1 accounts for sub-pixel rounding differences across browsers
    setTooltip(el.scrollHeight > el.clientHeight + 1 ? text : undefined)
  }, [text])

  useEffect(() => {
    updateTruncation()
    const el = ref.current
    if (!el || typeof ResizeObserver === 'undefined') return undefined

    const observer = new ResizeObserver(updateTruncation)
    observer.observe(el)
    return () => observer.disconnect()
  }, [updateTruncation])

  return (
    <span ref={ref} className={className} title={tooltip}>
      {text}
    </span>
  )
}

InstrumentTitle.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
}

export default InstrumentTitle
